<script setup>
  import { computed, inject } from 'vue'
  import CountryFlag from '@/components/CountryFlag.vue'

  const tournament = inject('tournament')
  const allTeams = inject('allTeams')

  const props = defineProps(['teamId', 'withFlag'])

  const showFlags = computed(() => {
    const tournamentSettings = tournament.value.settings || {}
    return tournamentSettings.showFlags === false ? false : true
  })
</script>

<template>
  <span v-if="showFlags && withFlag" class="me-2">
    <CountryFlag :country="allTeams[teamId]?.country" />
  </span>
  {{ allTeams[teamId]?.name || $t('team.unknown') }}
</template>
